// This file is part of InvenioRDM
// Copyright (C) 2023 CERN.
//
// Invenio App RDM is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

/**
 * Add here all the overridden components of your app. inspect using reactOverridableEnableDevMode()
 */

export const overriddenComponents = {
  "InvenioAppRdm.Deposit.LicenseField.container": () => null,
  "InvenioAppRdm.Deposit.CopyrightsField.container": () => null,
  "InvenioAppRdm.Deposit.AccordionFieldRecommendedInformation.container": () => null,
  "InvenioAppRdm.Deposit.AccordionFieldFunding.container": () => null,
  "InvenioAppRdm.Deposit.AccordionFieldAlternateIdentifiers.container": () => null,
  "InvenioAppRdm.Deposit.AccordionFieldRelatedWorks.container": () => null,
}
